module.exports = __webpack_public_path__ + "img/mic_small_disabled.05b4602b.svg";